enum SiteMapsStatic {
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description Get list path sitemap files
   */
  allSiteMap = "/v2/realestates/download-json",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description Get sitemap file
   */
  siteMapFile = "/v2/realestates/download-xml",
}

const SiteMapsDynamic = {};


export const SiteMapsEndpoints = {
  ...SiteMapsStatic,
  ...SiteMapsDynamic,
};

export type SiteMapsEndpoints = typeof SiteMapsEndpoints;
